/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./create-dco-dialog.vue?vue&type=template&id=54f9249c&"
import script from "./create-dco-dialog.vue?vue&type=script&lang=js&"
export * from "./create-dco-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports